import { render, staticRenderFns } from "./menu3.vue?vue&type=template&id=02153d69&scoped=true"
import script from "./menu3.vue?vue&type=script&lang=js"
export * from "./menu3.vue?vue&type=script&lang=js"
import style0 from "./menu3.vue?vue&type=style&index=0&id=02153d69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02153d69",
  null
  
)

export default component.exports